<template>
  <div
    class="mall-check-box"
    :class="{ 'mall-check-box--checked': checked && !disabled, 'mall-check-box--disabled': disabled }"
  >
    <img v-if="disabled" src="@/assets/mall/icn_check_line_disabled.svg" alt="" />
    <img v-else src="@/assets/mall/icn_check_line_white.svg" alt="" />
  </div>
</template>

<script>
// 표시 전용 체크박스 (클릭은 감싸는 영역에서 처리)
export default {
  name: 'MallCheckBox',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.mall-check-box {
  display: flex;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  padding: 4px;
  border-radius: 8px;
  background: #D1D6DB;
  box-sizing: border-box;
}

.mall-check-box img {
  display: block;
}

.mall-check-box--checked {
  background: #0096FF;
}

.mall-check-box--disabled {
  background: #F2F4F6;
}
</style>



// WEBPACK FOOTER //
// src/components/new/atoms/MallCheckBox.vue